
import * as ipxRuntime$icsxU7sH6G from '/var/www/canceller/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 600,
    "sm": 960,
    "md": 1264,
    "lg": 1440,
    "xl": 1904,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$icsxU7sH6G, defaults: {} }
}
        